import React from "react";
import { Link } from "react-router-dom";

import "./SidebarTile.less";

const defaultImg = `//dreamchimney.com/tracks/track_images/12208.jpg`;

const getYouTubeIdFromUrl = (url) => {
  if (!url) return null;
  const match = url.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/);
  return match && match[7] && match[7].length === 11 ? match[7] : null;
};

const resolveImg = (post) => {
  const { img_url, link_url } = post;
  if (img_url) {
    if (img_url.startsWith("http://")) return img_url.replace(/^http:\/\//i, "https://");
    if (img_url.startsWith("https://") || img_url.startsWith("//")) return img_url;
    return `//dreamchimney.com/${img_url.replace(/^\//, "")}`;
  }
  const ytId = getYouTubeIdFromUrl(link_url);
  return ytId ? `https://i3.ytimg.com/vi/${ytId}/hqdefault.jpg` : defaultImg;
};

const SidebarTile = ({ post }) => {
  if (!post || !post.slug) return null;
  const img = resolveImg(post);

  return (
    <Link to={`/${post.slug}`} className="sidebarTile">
      <img src={img} alt="" onError={(ev) => { ev.target.src = defaultImg; }} />
      <div className="sidebarTileBody">
        <div className="sidebarTileTitle">"{post.otd_title}" of the Day</div>
        {post.date && <div className="sidebarTileDate">{post.date}</div>}
      </div>
    </Link>
  );
};

export default SidebarTile;
